<template>
  <div class="space-y-4">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-lg font-semibold">Escalation Rules</h3>
        <p class="text-sm text-muted-foreground">
          Configure automatic escalation if alert is not acknowledged
        </p>
      </div>
      <button
        @click="onAdd()"
        class="ring-offset-background focus-visible:outline-hidden focus-visible:ring-ring inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 border-input bg-background hover:bg-accent hover:text-accent-foreground border h-9 rounded-md px-3"
      >
        <i class="icon-plus size-4" />
        Add Level
      </button>
    </div>
    <div
      v-for="(item, index) in val"
      :key="index"
      class="rounded-lg border bg-card text-card-foreground shadow-2xs"
      data-v0-t="card"
    >
      <div class="flex flex-row items-center justify-between p-6">
        <div class="flex flex-col space-y-1.5">
          <div class="flex items-center justify-between">
            <h3 class="font-semibold tracking-tight text-base">
              <div class="flex items-center gap-2">
                <i class="icon-circle-arrow-up h-5 w-5 text-orange-500" />
                Escalation Level {{ index + 1 }}
              </div>
            </h3>
          </div>
        </div>
        <i @click="onRemove(index)" class="icon-x size-4" />
      </div>
      <div class="p-6 pt-0 space-y-4">
        <div class="grid gap-4 md:grid-cols-2">
          <div class="space-y-2">
            <label
              class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Wait Time (minutes)
            </label>
            <el-input-number :min="0" v-model="item.after_min" />
            <p class="text-xs text-muted-foreground">
              Escalate if no acknowledgment within this time
            </p>
          </div>
          <div class="space-y-2">
            <label
              class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Escalation Recipients
            </label>
            <div class="relative w-full" style="height: 400px">
              <RecipientChannelCheckboxGroup
                :key="`EscalationSteps-inner` + index"
                v-model="item.recipient_channels"
                :loadMethod="listNotificationRecipientInChannels"
                :pageSize="200"
                class="absolute inset-0"
              />
            </div>
            <p class="text-xs text-muted-foreground">
              Choose who should be notified when the alert escalates
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listNotificationRecipientInChannels } from "@/api";
import RecipientChannelCheckboxGroup from "./RecipientChannelCheckboxGroup.vue";

export default {
  name: "EscalationSteps",
  components: {
    RecipientChannelCheckboxGroup,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      val: this.value ? [...this.value] : [],
    };
  },
  watch: {
    // val: {
    //   handler(newVal) {
    //     this.$emit("input", newVal);
    //   },
    //   deep: true,
    // },
    value: {
      handler(newVal) {
        if (newVal) {
          this.val = [...newVal];
        }
      },
      deep: true,
    },
  },
  methods: {
    onAdd() {
      this.val.push({
        after_min: 5,
        recipient_channels: [],
      });
      this.$emit("input", this.val);
    },
    async onRemove(index) {
      await this.$confirm(
        "Are you sure you want to remove this escalation level?",
        "Confirm Removal",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      );
      this.val.splice(index, 1);
      this.$emit("input", this.val);
    },
    listNotificationRecipientInChannels,
  },
};
</script>
